/**
 * @consideration Maybe this should be removed later to rely only on typescript
 */ var isObject = function isObject(o) {
    return o === Object(o) && !Array.isArray(o) && typeof o !== "function";
};
export default isObject;
